<template>
  <nav
    id="mainNav"
    class="navbar navbar-default navbar-full"
    :class="{ 'navbar-shadow': !showNavbar }"
  >
    <div class="container container-nav">
      <div class="navbar-header">
        <button
          aria-expanded="false"
          type="button"
          class="navbar-toggle collapsed"
          data-toggle="collapse"
          data-target="#bs"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <router-link class="navbar-brand page-scroll" to="/">
          <img class="logo" :src="logo" alt="Verloop_logo" />
        </router-link>
      </div>
      <div
        style="height: 1px;"
        role="main"
        aria-expanded="false"
        class="navbar-collapse collapse"
        id="bs"
      >
        <ul class="nav navbar-nav navbar-right">
          <li>
            <router-link to="/pricing.html">Pricing</router-link>
          </li>
          <li>
            <router-link to="/case-studies.html">Case Studies</router-link>
          </li>
          <li>
            <a href="https://blog.verloop.io" target="_blank">Blog</a>
          </li>
          <li>
            <a class="login-button" href="/app">Login</a>
          </li>
          <li>
            <a
              href="/app/signup/email?utm_source=top-menu&utm_medium=web-client&utm_campaign=direct-click"
              target="_blank"
            >
              Create Free
              Account
            </a>
          </li>
          <li>
            <router-link class="chat-button" to="/schedule-a-demo" target="_blank">Schedule A Demo</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "AppHeader",
  data() {
    return {
      logo: require("@/assets/images/logo-new-white.png"),
      showNavbar: true
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      if (window.scrollY > 30) {
        this.showNavbar = false;
        this.logo = require("@/assets/images/logo-new.png");
      } else {
        this.showNavbar = true;
        this.logo = require("@/assets/images/logo-new-white.png");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.logo {
  width: 176px;
  margin-top: -10px;
}

#mainNav {
  background-color: transparent;
  transition: background-color 0.25s linear, border-color 0.25s linear,
    color 0.25s linear;
}

.navbar {
  border: 0;
  border-radius: 0;
  margin-bottom: 0;
  margin-top: 0px;
  position: fixed;
  width: 100%;
  top: 0px;
  left: 0px;
  z-index: 9999;
}

.navbar-shadow {
  background-color: #ffffff !important;
  box-shadow: 0 0px 6px rgba(0, 0, 0, 0.16);
}

.navbar-default .navbar-nav > li > a {
  color: #ffffffb3;
  font-size: 14px;
  font-weight: 500;
  position: relative;
  padding: 26px 16px;
  text-transform: uppercase;
}

.navbar-default.navbar-shadow .navbar-nav > li > a {
  color: #47525d;
}

.navbar-default .navbar-nav > li > a:hover,
.navbar-default .navbar-nav > li > a:focus {
  color: #ffffff;
}

.navbar-default.navbar-shadow .navbar-nav > li > a:hover,
.navbar-default.navbar-shadow .navbar-nav > li > a:focus {
  color: #333333;
}

.navbar-default .navbar-nav > .active > a,
.navbar-default .navbar-nav > .active > a:focus,
.navbar-default .navbar-nav > .active > a:hover {
  color: #1f8ded;
  background-color: transparent;
}

.navbar-default .navbar-nav > li > a.chat-button {
  border-radius: 5px;
  border: 1px solid #ff7a59;
  padding: 8px 14px;
  color: #ffffff;
  background-color: #ff7a59;
  font-size: 14px;
  font-weight: 500;
  outline: 0;
  text-transform: uppercase;
  margin-left: 15px;
  margin-top: 16px;
  margin-bottom: 13px;
}

.navbar-default .navbar-nav > li > a.chat-button:hover,
.navbar-default .navbar-nav > li > a.chat-button:focus {
  background-color: #fff;
  color: #1f8ded;
  border: 1px solid #1f8ded;
}

.navbar-default .navbar-nav > li > a.whatsapp.chat-button:hover,
.navbar-default .navbar-nav > li > a.whatsapp.chat-button:focus {
  background-color: #fff !important;
  color: #128c7e;
  border: 1px solid #128c7e;
}

.container-nav {
  padding-right: 34px;
  padding-left: 34px;
}

@media (min-width: 768px) {
  .navbar-nav > li > a {
    padding-top: 20px;
    padding-bottom: 20px;
  }
}

.navbar-brand {
  height: 65px;
  padding: 20px 15px;
  overflow-y: hidden;
}

.navbar-default .navbar-toggle {
  border: 0px;
}

.navbar-default .navbar-toggle .icon-bar {
  background-color: #1f8ded;
}

.navbar-default .navbar-toggle:focus,
.navbar-default .navbar-toggle:hover {
  background-color: transparent;
  opacity: 0.7;
}

.navbar-toggle {
  margin-top: 17px;
}

.navbar-right .dropdown-menu {
  left: 0;
  right: auto;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-menu {
  display: none;
  position: absolute;
  background-color: #ffffff;
  min-width: 160px;
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.13);
  border: 0;
  top: 70px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.dropdown-menu > li > a {
  color: #898f92;
  font-size: 12px;
  text-decoration: none;
  display: block;
  padding-top: 5px;
  padding-bottom: 5px;
}

.dropdown-menu > li > a:focus,
.dropdown-menu > li > a:hover {
  color: #5bacdc;
  background-color: #f9fdff;
}

.dropdown:hover .dropdown-menu {
  display: block;
}
</style>

